export const digitalMarketingConst = {
  path: "/single-programs/digital-marketing",
  title: "ФАКУЛЬТЕТ БИЗНЕСА И IT – ЦИФРОВОЙ МАРКЕТИНГ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Цифровой маркетинг — ключ к успеху бизнеса в онлайн-пространстве</h2>
      <p>
        В современном мире быть онлайн — это не роскошь, а необходимость. Цифровой маркетинг — это профессия, которая находится на
        пересечении креативности, технологий и стратегического мышления. От управления рекламными кампаниями до глубокого анализа
        пользовательского поведения — вы станете экспертом в области, которая определяет, как бизнес общается с клиентом.
      </p>
      <p>
        Программа бакалавриата или магистратуры по digital-маркетингу подготовлена с учетом требований современной экономики и динамики
        интернет-среды. Студенты изучают как технические инструменты (SEO, таргетинг, аналитика), так и стратегические аспекты — поведение
        потребителей, цифровой бренд-менеджмент и управление рекламным бюджетом.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>SEO и поисковая оптимизация</li>
        <li>Контекстная и таргетированная реклама</li>
        <li>SMM и работа с социальными платформами</li>
        <li>Digital-стратегии и бренд-маркетинг</li>
        <li>Email-маркетинг и маркетинговые воронки</li>
        <li>Google Analytics, Tag Manager, Data Studio</li>
        <li>Визуальный и креативный контент</li>
        <li>Управление digital-проектами и маркетинговый UX</li>
        <li>Поведенческий анализ и автоматизация маркетинга</li>
      </ul>
      <p>
        Занятия сочетают теорию с практикой: реальные кейсы, работа с платформами Meta, Google, TikTok, анализ эффективности кампаний,
        создание лендингов и воронок продаж.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Digital-маркетолог / performance-маркетолог</li>
        <li>SEO / PPC специалист</li>
        <li>Контент-менеджер, копирайтер, SMM-менеджер</li>
        <li>Менеджер по интернет-рекламе</li>
        <li>Аналитик digital-трафика</li>
        <li>Руководитель digital-отдела или агентства</li>
        <li>Консультант по e-commerce и онлайн-продвижению</li>
      </ul>
      <h2>Зарплата в Европе:</h2>
      <p>
        от <strong>€45,000 до €80,000 в год,</strong> в зависимости от направления и опыта.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Диплом европейского образца с международным признанием</li>
        <li>Гибкий формат обучения: очно или дистанционно</li>
        <li>Преподаватели — действующие эксперты из digital-агентств</li>
        <li>Обучение на русском или английском языке</li>
        <li>Практика с международными платформами (Google, Meta, HubSpot и др.)</li>
        <li>Индивидуальный подход и сопровождение на всех этапах</li>
      </ul>
      <p>
        Цифровой маркетинг — это профессия будущего. Мы помогаем студентам стать востребованными специалистами, которые уверенно чувствуют
        себя в мире алгоритмов, трендов и креатива.
      </p>
      <h2>Как поступить?</h2>
      <p>
        Наша приёмная комиссия с радостью поможет вам выбрать подходящий формат, подготовить документы и оформить поступление без стресса.
      </p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии
    Цифровой маркетинг — ключ к успеху бизнеса в онлайн-пространстве
    В современном мире быть онлайн — это не роскошь, а необходимость. Цифровой маркетинг — это профессия, которая находится на пересечении креативности, технологий и стратегического мышления. От управления рекламными кампаниями до глубокого анализа пользовательского поведения — вы станете экспертом в области, которая определяет, как бизнес общается с клиентом.
    Программа бакалавриата или магистратуры по digital-маркетингу подготовлена с учетом требований современной экономики и динамики интернет-среды. Студенты изучают как технические инструменты (SEO, таргетинг, аналитика), так и стратегические аспекты — поведение потребителей, цифровой бренд-менеджмент и управление рекламным бюджетом.

    Что вы будете изучать?
    • SEO и поисковая оптимизация
    • Контекстная и таргетированная реклама
    • SMM и работа с социальными платформами
    • Digital-стратегии и бренд-маркетинг
    • Email-маркетинг и маркетинговые воронки
    • Google Analytics, Tag Manager, Data Studio
    • Визуальный и креативный контент
    • Управление digital-проектами и маркетинговый UX
    • Поведенческий анализ и автоматизация маркетинга
    Занятия сочетают теорию с практикой: реальные кейсы, работа с платформами Meta, Google, TikTok, анализ эффективности кампаний, создание лендингов и воронок продаж.

    Кем можно работать после окончания?
    • Digital-маркетолог / performance-маркетолог
    • SEO / PPC специалист
    • Контент-менеджер, копирайтер, SMM-менеджер
    • Менеджер по интернет-рекламе
    • Аналитик digital-трафика
    • Руководитель digital-отдела или агентства
    • Консультант по e-commerce и онлайн-продвижению

    Средний доход в Европе:
    от €45,000 до €80,000 в год, в зависимости от направления и опыта.

    Почему выбирают нас?
    • Диплом европейского образца с международным признанием
    • Гибкий формат обучения: очно или дистанционно
    • Преподаватели — действующие эксперты из digital-агентств
    • Обучение на русском или английском языке
    • Практика с международными платформами (Google, Meta, HubSpot и др.)
    • Индивидуальный подход и сопровождение на всех этапах

    Цифровой маркетинг — это профессия будущего. Мы помогаем студентам стать востребованными специалистами, которые уверенно чувствуют себя в мире алгоритмов, трендов и креатива.

    Как поступить?
    Наша приёмная комиссия с радостью поможет вам выбрать подходящий формат, подготовить документы и оформить поступление без стресса.
  `,
};
